import React from "react";
import type { ColumnsType } from "antd/es/table";
import { Pagination, Table } from "antd";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";

dayjs.extend(utc);
dayjs.extend(timezone);

const PresentTable = (props: any) => {
  const { presentList, loader, onShowSizeChange, defaultCurrent, current, total, pageSize, setCurrentPage } = props;

  const columns: ColumnsType<any> = [

    {
      title: 'Employee Code',
      dataIndex: 'employeeCode',
      key: 'code',
      width: "10%",
    },

    {
      title: "Employee name",
      dataIndex: "employeeName",
      key: "name",
      width: "20%",
    },
    {
      title: "Date",
      dataIndex: "date",
      key: "age",
      width: "20%",
    },
    {
      title: "In-Time ",
      dataIndex: "inTime",
      key: "inTime",
      width: "20%",
    },
    {
      title: "Out-Time",
      dataIndex: "outTime",
      key: "outTime",
      width: "20%",
    },
    {
      title: "Duration ",
      dataIndex: "duration",
      key: "address",
      width: "20%",
    },
  ];
  return (
    <div className="leave-management">
      <Table columns={columns} loading={loader} dataSource={presentList} pagination={false} />
      {total > 0 ? (
        <Pagination
          className="float-right flex flex-row ml-2"
          showSizeChanger
          onShowSizeChange={onShowSizeChange}
          defaultCurrent={defaultCurrent}
          current={current}
          total={total}
          pageSize={pageSize}
          onChange={(page) => {
            setCurrentPage(page);
          }}
        />
      ) : null}
    </div>
  );
};

export default PresentTable;
